import React, { Component, Fragment } from 'react';
import { Form, Grid } from '@solarwindscloud/cloud-ui';

import { isEmailValid } from '@solarwindscloud/swicus-validation';
import { EmailInput } from '../../../../components';
import styles from './ResetPasswordForm.module.scss';
import PropTypes from 'prop-types';
import { ErrorMessage } from '../../../../components/ErrorMessage';
import { SubmitButton } from './submit-button/submit-button';

const GRID_WIDTH = 16;

export default class ResetPasswordForm extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    email: PropTypes.string.isRequired,
    errors: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleEmailError: PropTypes.func.isRequired,
    handleChangeEmail: PropTypes.func.isRequired,
  };

  render() {
    const handleSubmit = this.props.handleSubmit;

    return (
      <Fragment>
        <p>Forgot your password?</p>
        <Form onSubmit={handleSubmit} method="POST" className={styles.form} error={this.hasFormError()}>
          {this.renderFormBody()}
        </Form>
      </Fragment>
    );
  }

  renderFormBody() {
    const { handleChangeEmail, errors, email } = this.props;
    return (
      <Grid verticalAlign="middle">
        <Grid.Column width={GRID_WIDTH}>
          {this.renderResetPasswordErrorIfNecessary(errors)}
          {this.renderInvalidResetPasswordTokenErrorIfNecessary(errors)}
          {this.renderEmailInput(handleChangeEmail, email)}
        </Grid.Column>
        <Grid.Column width={GRID_WIDTH} className={styles.resetButton}>
          <SubmitButton disabled={this.isSubmitDisabled()} loading={this.props.isLoading} />
        </Grid.Column>
      </Grid>
    );
  }

  renderEmailInput() {
    const { email, handleChangeEmail, handleEmailError } = this.props;
    return <EmailInput autoFocus value={email} onChange={handleChangeEmail} onError={handleEmailError} />;
  }

  renderInvalidResetPasswordTokenErrorIfNecessary(errors) {
    return (
      errors.invalidResetPasswordToken && <ErrorMessage message="Your password reset link is invalid or has expired." />
    );
  }

  renderResetPasswordErrorIfNecessary(errors) {
    return errors.resetPassword && <ErrorMessage message={errors.resetPassword} className={styles.errorMessage} />;
  }

  isSubmitDisabled() {
    return this.isEmptyEmailInput() || !isEmailValid(this.props.email) || this.props.isLoading;
  }

  isEmptyEmailInput() {
    return this.props.email.length === 0;
  }

  hasFormError() {
    const errors = this.props.errors;
    return Object.keys(errors).some(k => errors[k]);
  }
}
